var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarnedPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9999 16.0001L3.00407e-05 16.0002L0 14.0002L6.9999 14.0001L7 3.8283L3.05027 7.778L1.63606 6.36381L8 -0.000152588L14.364 6.36381L12.9498 7.778L9 3.82825L8.9999 16.0001Z",
    fill: "#09CB11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnedPoint);
export default __webpack_public_path__ + "static/media/EarnedPoint.68d577334d48e5fbf73f4dc03c91a090.svg";
export { ForwardRef as ReactComponent };